/* eslint-disable import/prefer-default-export */
export const cardTypes = ['Process']
